import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { AesEncDecService } from '../../../core/services/aes/aes-enc-dec.service';
import { environment } from '../../../../environments/environment';
import { FileDownloadService } from '../../../core/services/DownloadService/file-download.service';

@Component({
  selector: 'app-order-success',
  standalone: true,
  imports: [
    MatButtonModule,
    CommonModule,

  ],
  templateUrl: './order-success.component.html',
  styleUrl: './order-success.component.scss'
})
export class OrderSuccessComponent implements OnInit {
  private route = inject(ActivatedRoute);

  private localStorage = inject(AesEncDecService);
  orderNumber: string
  router = inject(Router);

  private fileDownloadService = inject(FileDownloadService)

  fromExcel: boolean = false;
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.orderNumber = params['id'];
      this.fromExcel = params['source'] === 'excel';
    })
  }
  view(): void {
    this.router.navigateByUrl('catalogue-view');
  }
  download(): void {
    const response = JSON.parse(this.localStorage.getData("downloadOrderExcelReport"));
    const filename = response.fileName;
    const blobUrl = environment.OrderExcelDomain + filename;
    this.fileDownloadService.downloadFileFromBlobUrl(blobUrl, filename);
  }
}
